import OnboardingTrackingService from "../../services/OnboardingTrackingService.vue";
import onboardingTrackingRoutes from "./routes";
import resizableColumns from "./resizableColumns";

/**
 * Single connection point for the onboarding-tracking module.
 *
 * 1) Register the API client + curl-repro error handling app-wide:
 *      import OnboardingTracking from "@/views/OnboardingTracking";
 *      Vue.use(OnboardingTracking);
 *    -> exposes `this.$onboardingTrackingService` in every component, plus the
 *       `v-trk-resizable` directive for drag-to-resize table columns.
 *
 * 2) Add the tracking pages to the host app's own router config (vue-router 3
 *    builds its route matcher once at construction time, so routes must be
 *    spread in before `new Router(...)`, not pushed in afterwards):
 *      import { onboardingTrackingRoutes } from "@/views/OnboardingTracking";
 *      children: [...otherRoutes, ...onboardingTrackingRoutes]
 */
function install(Vue) {
  if (install.installed) {
    return;
  }
  install.installed = true;
  Vue.use(OnboardingTrackingService);
  Vue.use(resizableColumns);
}

export default { install };
export { onboardingTrackingRoutes };
